import { some as any, pickBy, isEqual } from 'lodash';

var PropertyHelperMixin = {

  /**
   * This method will check if any of the declared updatable props are changed
   * in the passed props
   * @param props The props to compare with
   * @returns {Boolean}
   */
  propsShouldUpdate: function (props) {
    var that = this;
    return any(this.updatableProps, function (handler, prop) {
      return !isEqual(that.props[prop], props[prop]);
    });
  },

  /**
   * Calculates a list of update methods to run based on the updatable props
   * which is compared to the passed props param
   * @param props The props to compare with
   * @returns {Boolean}
   */
  propUpdateMethods: function (props) {
    var that = this;
    return pickBy(this.updatableProps, function (handler, prop) {
      return !isEqual(that.props[prop], props[prop]);
    });
  },

  /**
   * General should component update for all classes using this mixin.
   */
  shouldComponentUpdate: function (nextProps, nextState) {

    // If state was updated then update component
    if (!isEqual(this.state, nextState)) {
      return true;
    }
    // If children were updated then update component
    if (!isEqual(this.props.children, nextProps.children)) {
      return true;
    }
    // Check if any properties were updated
    return this.propsShouldUpdate(nextProps);
  }

};

export default PropertyHelperMixin;
